/* ScheduleStatusComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./ScheduleStatusRenderer");

class ScheduleStatusComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);
        this._value = value;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /* *****************************************
    /* START PUBLIC API METHODS
    /* ***************************************** */
    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setScheduleStatus(newVal);
        }
    }

    getValue() {
        return this.getScheduleStatus();
    }

    setScheduleStatus(newVal) {
        this._value = newVal;
        this.emit("ScheduleStatus", newVal);
        return this;
    }

    getScheduleStatus() {
        return this._value;
    }

    /* *****************************************
    /* END PUBLIC API METHODS
    /* ***************************************** */
}

module.exports = ScheduleStatusComponent;
